import {useSelector} from "react-redux";
import {RootSliceType} from "redux/reducers/rootReducer";
import {IHomeNotices} from "../reducers/homeNoticesSlice";

export const useHomeNoticesSelector = () => {
  const homeNotices = useSelector<RootSliceType, IHomeNotices["homeNotice"]>(
    (state) => state.homeNotices.homeNotice
  );

  const loading = useSelector<RootSliceType, IHomeNotices["loading"]>(
    (state) => state.homeNotices.loading
  );

  return {
    homeNotices,
    loading
  };
};

export default useHomeNoticesSelector;